import { CIS_FRAMEWORK_ID, CIS_NOTICE } from '../../../shared/compliance/engine/notices.mjs';

/**
 * The protective line under anything that shows CIS control references or CIS readiness (Hugo Andrade, 2026-10-21,
 * ENTRAID-347): a readiness indication only, never compliance, certification, attestation or endorsement. The text
 * lives once in the compliance engine (notices.mjs), shared with the reports.
 */
export default function CisNotice({ className = 'text-xs text-ipc-muted' }) {
  return <p data-testid="cis-notice" className={className}>{CIS_NOTICE}</p>;
}

/** True when any of these framework ids is the CIS benchmark. */
export const mentionsCis = (frameworkIds) => (Array.isArray(frameworkIds) ? frameworkIds : []).includes(CIS_FRAMEWORK_ID);
